import Parse from "parse"

const ProductionSubstitution = Parse.Object.extend("ProductionSubstitution")

/**
 * create production substitution for the future and for already existing production step executions
 * in the second case the substitution is already applied to pse
 * @param {String} originalSupplierItemId
 * @param {String} replacementSupplierItemId
 * @param {Array<String>} productionStepExecutionsIds
 * @param {Array<String>} recipesIds
 * @param {Date} startDate
 * @param {Date} endDate
 * @returns 
 */

export const loadProductionSubstitutions = async ({
	includes = [],
	selects = [],
	toJSON = true
}) => {

	try {
		const productionSubstitutionsQuery = new Parse.Query(ProductionSubstitution)
			.notEqualTo("deleted", true)
			.descending("startDate")

		if (includes && includes.length && Array.isArray(includes)) {
			productionSubstitutionsQuery.include(includes)
		}
		if (selects && selects.length && Array.isArray(selects)) {
			productionSubstitutionsQuery.select(selects)
		}

		const productionSubstitutions = await productionSubstitutionsQuery.find()
		return toJSON ? productionSubstitutions.map(productionSubstitution => productionSubstitution.toJSON()) : productionSubstitutions
	}
	catch (e) {
		console.error("Error loading production substitutions", e)
		return []
	}
}
